import React from "react";
import { Logo } from "./brand/Logo";
import { Mail, Phone, Linkedin, MapPin } from "lucide-react";

const RESUME_URL =
  "https://customer-assets.emergentagent.com/job_psoft-consulting/artifacts/4bcwiez1_Vijay_Rajgopalan_Resume.pdf";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1F2326] text-[#F7F5F0]" data-testid="site-footer">
      <div className="container-app py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 max-w-sm text-[#F7F5F0]/70 leading-relaxed" data-testid="footer-tagline">
              Independent Oracle PeopleSoft consulting — administration, upgrades and
              cloud migrations across HCM, FSCM and Campus Solutions.
            </p>
            <div className="mt-8 flex items-center gap-3" data-testid="footer-social">
              <a
                href="https://www.linkedin.com/in/vjrajgopalan/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-[#F7F5F0]/30 flex items-center justify-center hover:bg-[#F7F5F0] hover:text-[#1F2326] transition-colors"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="mailto:vjrajgopalan@hotmail.com"
                className="w-10 h-10 border border-[#F7F5F0]/30 flex items-center justify-center hover:bg-[#F7F5F0] hover:text-[#1F2326] transition-colors"
                aria-label="Email"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="label-eyebrow !text-[#E89A9C]">Navigate</div>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["about", "About"],
                ["services", "Services"],
                ["industries", "Industries"],
                ["recommendations", "Recommendations"],
                ["contact", "Contact"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollTo(id)}
                    className="text-[#F7F5F0]/80 hover:text-[#F7F5F0] hover:underline underline-offset-4 transition-colors"
                    data-testid={`footer-nav-${id}`}
                  >
                    {label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href={RESUME_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  download="Vijay_Rajgopalan_Resume.pdf"
                  className="text-[#F7F5F0]/80 hover:text-[#F7F5F0] hover:underline underline-offset-4 transition-colors"
                  data-testid="footer-resume"
                >
                  Résumé (PDF)
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="label-eyebrow !text-[#E89A9C]">Contact</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Mail className="w-3.5 h-3.5 text-[#E89A9C]" />
                <a href="mailto:vjrajgopalan@hotmail.com" className="hover:underline underline-offset-4">
                  vjrajgopalan@hotmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-3.5 h-3.5 text-[#E89A9C]" />
                <a href="tel:+16172852331" className="hover:underline underline-offset-4">
                  +1 617 285 2331
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-3.5 h-3.5 text-[#E89A9C]" />
                Boston, Massachusetts
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F7F5F0]/15 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-[#F7F5F0]/50">
          <div data-testid="footer-copyright">
            © {year} Excelsior Consulting · excelsiorconsulting.us · All rights reserved.
          </div>
          <div className="font-mono tracking-widest uppercase">
            Independent · Boston · Established 2025
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
